import React from 'react';
import Spinner from './Spinner';

export default (props) => (
    <div className='loading-cover loading-cover-center' {...props}>
        <div className="row h-100 justify-content-center align-items-center">
            <Spinner />
        </div>
    </div>
);